import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import { Box } from "@mui/material";

import { Stepper } from "../../types/components/Stepper";

interface StepProps {
  currentStep: number;
  steps: Stepper[];
  onClick: (step: number) => void;
}

const AppStepper: React.FC<StepProps> = ({ steps, currentStep, onClick }) => {
  const activeColor = (step: number) =>
    currentStep >= step ? `bg-accentColor` : "bg-gray-300";
  const isFinalStep = (step: number) => step === steps.length;

  return (
    <Box sx={{ width: "100%" }}>
      <div className="flex items-center app-stepper">
        {steps.map((step, index) => {
          return (
            <React.Fragment key={index}>
              <div
                className={`flex justify-center items-center w-8 h-8 rounded-full ring-1 ${
                  step.isCompleted &&
                  (currentStep === step.id || currentStep > step.id)
                    ? "ring-accentColor"
                    : "ring-gray-500"
                }`}
                onClick={() => onClick(step.id)}
              >
                {step.isCompleted ? (
                  <CheckCircleIcon
                    color="warning"
                    style={{ marginBottom: "auto", marginTop: "auto" }}
                  />
                ) : (
                  <CircleIcon
                    sx={{ fontSize: 12 }}
                    color={currentStep === step.id ? "warning" : "action"}
                  />
                )}
              </div>
              {isFinalStep(step.id) ? null : (
                <div className={`flex-1 h-0.5 ${activeColor(step.id)}`}></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </Box>
  );
};

export default AppStepper;
